import { ReactElement, useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { HttpService } from "../../../services/HttpService";
import StatusPill from "../../../uiComponents/StatusPill/StatusPill";
import Loading from "../../../components/Loading/Loading";
import FilePreviewOverlay from "../../../uiComponents/FilePreviewOverlay/FilePreviewOverlay";

import RequestShippmentDialog from "./Dialog/RequestShippmentDialog";
import { Order } from "./types";


function PandingDocuments(): ReactElement {


    const [pdfUrl, setPdfUrl] = useState('');
    const [orders, setOrders] = useState<Order[]>([]);
    const [isLoaded, setLoaded] = useState<boolean>(false);
    const [isDataExist, setDataExist] = useState<boolean>(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);


    const closePreviewModal = useCallback(() => {
        setPdfUrl('');
    }, []);

    const onPreviewhandler = useCallback((orderNumber: string, documentStatus: string): void => {
        setPreviewLoading(true);
        HttpService.get(
            `/api/return-shipment/presigned-url/${orderNumber}/file/${documentStatus}`
        ).then(res => {
            setPdfUrl(res.data.url);
        }).catch().finally(() => {
            setPreviewLoading(false);
        });
    }, [orders]);

    useEffect(() => {
        HttpService.get(
            "/api/return-shipment/available-orders"
        ).then(res => {
            setOrders(() => res.data.sort((a: Order, b: Order) => {
                return moment(b.grantDate).diff(moment(a.grantDate)) > 0 ? 1 : -1;
            }));
            setDataExist(Boolean(res.data.length));
        }).catch(error => {

        }).finally(() => setLoaded(true))

        return () => {
            setOrders([]);
            setLoaded(false);
            setDataExist(false);
        }
    }, []);

    return (
        <div className="w-full h-full flex flex-column row-gap-4">
            <div className="w-full flex justify-content-end">
                {
                    orders.length ? (
                        <Button label="Request Physical Copies" onClick={() => setModalOpen(true)}/>
                    ) : null
                }
            </div>
            <div className="grid -mx-3 h-full overflow-auto">
                {
                    isLoaded ? (
                        isDataExist ? (
                            orders.map((order: Order) => {
                                return (
                                    <div key={order.orderNumber} className="p-3 col-12 sm:col-6 md:col-4">
                                        <div className="flex flex-column gap-4 p-4 p-card p-component">
                                            <div className="flex justify-content-between align-items-center">
                                                <div className="font-bold text-xl text-color">
                                                    <span className="mr-1">Order</span>
                                                    <span>#{order.orderNumber}</span>
                                                </div>
                                                <div className="font-semibold text-base">
                                                    {
                                                        order.remainingDays ? (
                                                                <span className="font-semibold text-sm text-green-800 bg-green-100 border-green-300 px-2 py-1 border-round-md">
                                                                    Free storage ({order.remainingDays} days remaining)
                                                                </span>
                                                        ) : (
                                                            order.physicalCopyStatus !== "NONE" ? (
                                                                <StatusPill hideIcon status={order.physicalCopyStatus} />
                                                            ): null
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="font-normal text-lg text-color mt-1">
                                                    <span className="mr-1">Grant Date:</span>
                                                    <span className="mr-1">
                                                        {
                                                            (() => {
                                                                const date = moment(order.grantDate);
                                                                return date.isValid() ? date.format('MMM DD, YYYY') : 'N/A';
                                                            })()
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 border-y-1 surface-border py-3">
                                                <span className="font-semibold text-base text-color">Filing Status:</span>
                                                <span className="font-semibold text-color ml-2">
                                                    <StatusPill status={order.status} />
                                                </span>
                                            </div>
                                            {
                                                order.documentsAvailable.length ? (
                                                    <div className="flex-grow-1">
                                                        <div className="font-semibold text-lg text-color">
                                                            Documents Available:
                                                        </div>
                                                        {
                                                            order.documentsAvailable.length ? (
                                                                <ul className="list-none pt-2">
                                                                    {
                                                                        order.documentsAvailable.map((document, idx) => {
                                                                            return (
                                                                                <li key={order.orderNumber.concat(`-${document.status}`)}
                                                                                    className="flex justify-content-between align-items-center">
                                                                                    <div>
                                                                                        <span className="mr-2 text-color">
                                                                                            <i className={classNames("text-base pi", {
                                                                                                "pi-file-word": document.status === "ACKNOWLEDGED_COPY",
                                                                                                "pi-envelope": document.status === "MAILED_COPY",
                                                                                                "pi-file": document.status === "RETURN_RECEIPT",
                                                                                            })} />
                                                                                        </span>
                                                                                        <span className="font-normal text-lg text-color">
                                                                                            {document.fileName}
                                                                                        </span>
                                                                                    </div>
                                                                                    <Button
                                                                                        text
                                                                                        size="small"
                                                                                        label="Preview"
                                                                                        icon="pi pi-eye"
                                                                                        onClick={() => onPreviewhandler(order.orderNumber, document.status)}
                                                                                    />
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            ) : null
                                                        }
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <div className="py-6 w-full h-full flex justify-content-center r">
                                 <div className="flex flex-column justify-content-center align-items-center gap-3">
                                    <div className="border-circle p-4 bg-gray-100 flex-grow-1">
                                        <i className="pi pi-file-o text-4xl text-color"/>
                                    </div>
                                     <h3 className="text-lg font-semibold mt-2">No Available Physical Copies</h3>
                                     <div className="text-color text-base font-normal text-center max-w-27rem">
                                        You don't have any physical copies available to ship to you at this 
                                        time. Physical copies will appear here when they're ready to be requested.                                  
                                     </div>
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="w-full h-full flex justify-content-center aligin-items-center">
                            <Loading horizontalSpacing={82} />
                        </div>
                    )
                }
            </div>
            <RequestShippmentDialog orders={orders} visible={isModalOpen} onCloseHandler={() => setModalOpen(false)} />
            <FilePreviewOverlay
                preview={pdfUrl}
                isLoading={previewLoading}
                closePreview={closePreviewModal}
                hideDownloadButton
            />
        </div>
    );
}

export default PandingDocuments;
